import React from "react";
import styled from "styled-components";
import { Title } from "./shared/Title";
import { CTAButton } from "./shared/Button";
import { scrollToSection } from "./shared/utils";
import { CTAText } from "./shared/CTAText";

const Wrapper = styled.div`
  background-image: url("img/bg-main-page.png");
  background-size: cover;
  background-position: bottom right;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px 0 40px;
  box-sizing: border-box;
`;

const WrapperContent = styled.div`
  max-width: 850px;
  padding: 0 5%;
`;

const FirstText = styled.div`
  font-size: 14px;
  background-color: #c5f1f6;
  padding: 2px 10px;
  border-radius: 80px;
  display: inline-flex;
  align-items: center;
`;

const MainText = styled.p`
  text-align: left;
  margin-bottom: 40px;
`;

const Subjects = styled.img`
  max-width: 500px;
  width: 100%;
  height: auto;
  margin-bottom: 40px;
`;

export const MainScreen = () => {
  return (
    <Wrapper id="top">
      <WrapperContent>
        <FirstText>
          🚀 1er bootcamp que incluye proyecto final en equipo profesional
        </FirstText>
        <Title>
          Programa un nuevo comienzo: <br />
          de espectador a creador en el mundo digital
        </Title>
        <p style={{ fontSize: 24 }}>
          El código lo aprendes en cualquier tutorial, aquí te formamos para que
          pases esa primera entrevista de trabajo
        </p>
        <MainText>
          Sabes que quieres algo más. Algo que te rete, que te motive, que te
          haga sentir que avanzas. <b>Aprender a programar</b> es solo el
          principio del camino. En Beyond te sumergirás en un entorno real de{" "}
          <b>desarrollo de software</b>, colaborando en equipo y construyendo un
          proyecto desde cero tal y como se hace en la industria.
        </MainText>
        <CTAText>Descifra el código de tu futuro</CTAText>
        <Subjects src="/img/subjects.svg" />
        <CTAButton handleClick={() => scrollToSection("contact")}>
          Quiero ser <b>Desarrollador Web</b> 👩‍💻
        </CTAButton>
      </WrapperContent>
    </Wrapper>
  );
};
